import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import React, { useEffect, useId, useState } from 'react';

interface StyledButtonProps {
  visible: boolean;
}

const StyledButton = styled.div<StyledButtonProps>`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0057ff;
  border: 1px solid white;
  opacity: 0.7;
  border-radius: 5px;
  width: 52px;
  height: 48px;
  left: 20px;
  bottom: -72px;
  color: white;
  cursor: pointer;
  z-index: 999;
  transition: all 300ms ease-out;

  &:hover {
    opacity: 1;
  }

  ${({ visible }) =>
    visible &&
    css`
      transform: translate3d(0px, -100px, 0px);
    `}

  ${({ visible }) =>
    !visible &&
    css`
      transform: translate3d(0px, 150px, 0px);
    `}
`;

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const scrollTopId = useId();

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 200) {
      setVisible(true);
    } else if (scrolled <= 200) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
    return () => {
      window.removeEventListener('scroll', toggleVisible);
    };
  }, []);

  return (
    <StyledButton id={`${scrollTopId}-button`} data-testid="scroll-top-button" visible={visible} onClick={scrollToTop}>
      <ArrowUpwardIcon />
    </StyledButton>
  );
};

export default ScrollToTopButton;
